import { FC } from "react";

import { FormControl, FormControlLabel } from "@mui/material";

import { Checkbox } from "@/ui-kit";

interface ICheckBoxInputProps {
  fieldName: string;
  label: string;
  id?: string;
  disabled?: boolean;
  errors: any;
  touched: any;
  values: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  handleSubmit?: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
}

const CheckBoxInput: FC<ICheckBoxInputProps> = ({
  label,
  fieldName,
  id = "",
  disabled = false,
  values,
  errors,
  touched,
  setFieldValue,
  handleSubmit,
}) => {
  const toggleCheckbox = (value: string) => {
    const currentValues = values[fieldName] || [];
    const updatedValues = currentValues.includes(value)
      ? currentValues.filter((val: string) => val !== value)
      : [...currentValues, value];

    setFieldValue(fieldName, updatedValues);
    handleSubmit?.();
  };

  const isChecked = id ? values[fieldName]?.includes(id) : values[fieldName]?.includes(label);

  return (
    <FormControl
      hiddenLabel={!values[fieldName]}
      error={!!errors[fieldName] && !!touched[fieldName]}
      sx={{
        "&& .MuiFormControlLabel-root.Mui-disabled": {
          opacity: 0.2,
        },
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            name={fieldName}
            sx={{
              padding: "4px",
              color: "rgba(186, 144, 92, 0.5) !important",
              border: "none !important",
              background: "transparent !important",
              "&.Mui-checked": {
                color: "#9cd3fd !important",
              },
              "& .MuiSvgIcon-root": {
                fontSize: "1.1rem",
                scale: "1 !important",
              },
            }}
          />
        }
        disabled={disabled}
        checked={isChecked || false}
        onChange={() => (id ? toggleCheckbox(id) : toggleCheckbox(label))}
        label={label}
        sx={{
          alignItems: "center",
          margin: 0,
          padding: "3px 0",
          "& .MuiCheckbox-root": {
            padding: "4px",
            marginTop: "-1px",
          },
          "&& .MuiFormControlLabel-label": {
            color: "#EDD5BE",
            fontSize: "0.875rem",
            fontFamily: "Raleway, sans-serif",
            fontWeight: 400,
            transition: "color 0.2s ease",
            paddingLeft: "4px",
          },
          "&& .MuiFormControlLabel-label.Mui-disabled": {
            color: "#6b5744 !important",
          },
          "&:hover .MuiFormControlLabel-label": {
            color: "#FBF4EC",
          },
          "&:hover .MuiCheckbox-root": {
            color: "#9cd3fd !important",
          },
        }}
      />
    </FormControl>
  );
};
export default CheckBoxInput;
